import React from 'react';
import AisinoForm from "./baseComponent/form/AisinoForm";
import AisinoModal from "./baseComponent/modal/AisinoModal";
import {getLanguage, validateMessages} from "./source/js/common";
import {FormItemInput} from "./common/form";
import AisinoButtonArea from "./common/area/AisinoButtonArea";
import AisinoButton from "./baseComponent/button/AisinoButton";
import {AisinoPassword} from "./baseComponent/form";
import AisinoFormItem from "./baseComponent/form/AisinoFormItem";
import CloseSquareOutlined from "@ant-design/icons/es/icons/CloseSquareOutlined";
import CheckSquareOutlined from "@ant-design/icons/es/icons/CheckSquareOutlined";
import AisinoInputAndButton from "./baseComponent/form/input/AisinoInputAndButton";
import {postSync} from "./common/utils/http";
import {aisinoCancelConfirmModal, aisinoInfoModal} from "./common/modal/AisinoModalMethod";
import {pwdCheck} from "./common/utils/StringUtils";

const formLayout = {
    labelCol: {span: 6},
    wrapperCol: {
        xs: {span:10,offset: 0},
        sm: {span:10,offset: 2},
        md: {span:10,offset: 2},
        lg: {span:10,offset: 2}
    }
};
const itemLayout={
    wrapperCol: {
        xs: {span:12,offset: 0},
        sm: {span:12,offset: 2},
        md: {span:12,offset: 2},
        lg: {span:12,offset: 2}
    }
}

const commonLan = require('./constant/js/formItemNameLabel/'+getLanguage()+'/common.js');
const loginLan = require('./constant/js/formItemNameLabel/'+getLanguage()+'/login.js');
const profileLan = require('./constant/js/formItemNameLabel/'+getLanguage()+'/profile.js');
class RegisterPage extends React.Component {
    constructor(props){
        super(props);
        this.state={
            visible:false,
            otpBtnStatus:false,
            otpIntervalId:'',
            prevSeconds:60
        }
        this.formRef=React.createRef();
    }

    setModal1Visible(flag){
        if(!flag){
            this.formRef.current.resetFields();
        }
        this.setState({
            visible:flag
        })
    }
    submitRegister(){
        const that = this;
        const form = that.formRef.current;
        form.validateFields().then(values => {
            postSync("aisino/portalIndex/userRegister",values).then(response=>{
                if(response===true){
                    aisinoInfoModal(commonLan.registerSuccess+values.email,function(){
                        that.setModal1Visible(false);
                    })
                }
                if(response==='2'){
                    aisinoInfoModal(commonLan.otpExpired);
                }
                if(response==='3'){
                    aisinoInfoModal(commonLan.invalidOTP);
                }
            })
        })
    }
    cancel(){
        const that = this;
        aisinoCancelConfirmModal(function(){
            that.setModal1Visible(false);
        })
    }
    sendOtp(){
        const that = this;
        const form = that.formRef.current;
        if(form.getFieldError("email").length){
            return;
        }
        let formData = form.getFieldsValue();
        postSync("aisino/portalIndex/accountCheck",{email:formData.email}).then(res=> {
            if (res) {
                aisinoInfoModal(commonLan.emailHasBeenRegistered);
            }else{
                postSync("aisino/portalIndex/sendOTP",{email:formData.email}).then(response=>{
                    if(response){
                        if(response==='1'){
                            aisinoInfoModal(commonLan.emailNotEmpty);
                            return ;
                        }
                        if(response==='2'){
                            aisinoInfoModal(commonLan.emailIncorrect);
                            return ;
                        }
                        that.state.otpBtnStatus=true;
                        that.state.prevSeconds=Number(response);
                        that.setState({})
                        that.state.otpIntervalId=setInterval(() => {
                            that.state.prevSeconds=that.state.prevSeconds-1;
                            if(that.state.prevSeconds===0){
                                that.state.otpBtnStatus=false;
                                clearInterval(that.state.otpIntervalId)
                            }
                            that.setState({})
                        }, 1000);
                    }
                })
            }
        })
    }

    pwdChange(){
        const form =this.formRef.current;
        if(form.getFieldValue("pwdagain")){
            form.validateFields(["pwdagain"]);
        }
    }
    render() {
        const{otpBtnStatus,prevSeconds} = this.state;
        let buttonModules=[
            <AisinoButton type="primary" icon={<CheckSquareOutlined/>} onClick={()=>this.submitRegister()} >{commonLan.register}</AisinoButton>,
            <AisinoButton htmlType="button" icon={<CloseSquareOutlined/>} onClick={()=>this.cancel()}>{commonLan.cancelButton.label}</AisinoButton>,
        ];
        return(
            <AisinoModal
                title={commonLan.register}
                style={{ top: 20 }}
                visible={this.state.visible}
                onOk={() => this.setModal1Visible(false)}
                onCancel={() => this.setModal1Visible(false)}
                forceRender={true}
                maskClosable={false}
                width={600}
                footer={null}>
                <AisinoForm {...formLayout} validateMessages={validateMessages()}
                            ref={this.formRef} >
                    <FormItemInput name={"userName"} label={profileLan.userName.label} placeholder={commonLan.enterYourUserName} rules={[{required: true},{max:150}]}/>
                    <FormItemInput name={"contactNum"} label={profileLan.contactNumber.label} placeholder={commonLan.enterYourContactNumber}  rules={[{required: true},{max:50}]}/>
                    <AisinoFormItem maxLength={100} {...itemLayout} name={"email"} label={loginLan.email.label}  rules={[{required: true},{type:"email"},{max:100}]}>
                        <AisinoInputAndButton  placeholder={commonLan.validEmailAddress}  button_content={otpBtnStatus?prevSeconds+loginLan.second:loginLan.sendOTP.label} button_disabled={otpBtnStatus} button_click={()=>this.sendOtp()} />
                    </AisinoFormItem>
                    <FormItemInput maxLength={6} name={"otp"} label={"OTP"} rules={[{required: true},{max:6}]} placeholder={loginLan.enterOTP}/>
                    <div id={"forgetPwdNote"}>
                        <span>{loginLan.note}</span>
                    </div>
                    <AisinoFormItem label={loginLan.pwd} name={"pwd"} rules={[{required: true},
                        ({getFieldValue}) => ({
                            validator(rule, value) {
                                if(value){
                                    let res = pwdCheck(value);
                                    if(res === 3){
                                        return  Promise.reject(commonLan.pwdIncorrect);
                                    }
                                    else if(res === 1){
                                        return  Promise.reject(commonLan.pwdHasSpecialCharacter);
                                    }
                                    else{
                                        return Promise.resolve();
                                    }
                                }
                                return Promise.resolve();
                            },
                        })
                    ]} onChange={()=>this.pwdChange()}>
                        <AisinoPassword maxLength={20} placeholder={commonLan.pwdFormatIncorrect}/>
                    </AisinoFormItem>
                    <AisinoFormItem label={loginLan.confirmPassword} name={"pwdagain"} rules={[{required: true},
                        ({getFieldValue}) => ({
                            validator(rule, value) {
                                if(value && value !==getFieldValue('pwd')){
                                    return  Promise.reject(commonLan.passwordIsDifferentFromNewPassword);
                                }
                                return Promise.resolve();
                            },
                        })
                    ]}>
                        <AisinoPassword maxLength={20} placeholder={commonLan.pwdFormatIncorrect}/>
                    </AisinoFormItem>
                    <div className="pageBottomButtonBg">
                        <AisinoButtonArea buttonModules={buttonModules} style={{justifyContent: "center"}}/>
                    </div>
                </AisinoForm>
            </AisinoModal>
        )
    }


}
export default RegisterPage;
